import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconHeavyrain = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 18 18",
	width: 24,
	height: 24,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m1.27 16.69 2.96-2.89M6.39 16.69l2.96-2.89M11.51 16.69l2.96-2.89M8.21 17.5l3.7-3.7M3.09 17.5l3.7-3.7M15.43 6.19a2.22 2.22 0 0 0-2.31-3.08 4.07 4.07 0 0 0-7.85 1.11 3.7 3.7 0 0 0 .35 7.38h8.15a3 3 0 0 0 1.66-5.41Z",
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export { SvgIconHeavyrain as ReactComponent };
